require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-hub-tholen.json") })
        }
      }, "path---projecten-hub-tholen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-hub-tholen!./.cache/json/projecten-hub-tholen.json
// module id = 418
// module chunks = 231608221292675